import { useQuery } from "@tanstack/react-query";
import { fetchMe } from "#/lib/api/auth";
import { queryKeys } from "./query-keys";
import { useAuth } from "./use-auth";

export function useMe() {
	const { isAuthenticated, userId } = useAuth();

	return useQuery({
		queryKey: queryKeys.auth.me(userId),
		queryFn: fetchMe,
		enabled: isAuthenticated,
		staleTime: 60_000,
	});
}
